<security-logout-component></security-logout-component>
